import type { Icon } from '../../../src/lib/types'
export const mdiContentPaste: Icon = {
  "id": "content-paste",
  "name": "Content Paste",
  "path": "M19,20H5V4H7V7H17V4H19M12,2A1,1 0 0,1 13,3A1,1 0 0,1 12,4A1,1 0 0,1 11,3A1,1 0 0,1 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5A2,2 0 0,0 3,4V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V4A2,2 0 0,0 19,2Z",
  "as": [],
  "tags": []
}
export default mdiContentPaste